// extracted by mini-css-extract-plugin
module.exports = {"section":"section__Hxnmd","title":"title__RazH1","collapsed":"collapsed__HOEhn","content":"content__jx-mf"};